import { Storage } from 'aws-amplify';
import { Amplify } from 'aws-amplify';
import { awsConfig } from '../config/aws-export';

async function S3UploadHookImport(file, key) {
    Amplify.configure(awsConfig);

    try {
        const result = await Storage.put(`../transfer-files/${key}`, file, {
            contentType: file.type,
            ACL: 'private', // Set ACL to 'private', 'public-read', 'protected', etc.
        });
        return result.key; // Return the key of the uploaded file
    } catch (error) {
        console.log("error", error);
        throw new Error('S3 upload failed');
    }
}

export default S3UploadHookImport;
